import store from '../../store'
import Layout from '../../views/admin/layout/Layout'
import { asyncRouterMap, async2RouterMap, unconfirmedRouterMap, constantRouterMap } from '@/router'

/**
 * meta role
 * @param roles
 * @param route
 */
function hasPermission(role, route, features, relationRole) {
  let pass = true
  if (route.meta) {
    if (route.meta.feature && pass) {
      pass = features[route.meta.feature]
    }
    if (route.meta.roles && pass) {
      pass = route.meta.roles.indexOf(role) >= 0
    }
    if (route.meta.relationRoles && pass) {
      pass = route.meta.relationRoles.indexOf(relationRole) >= 0
    }
  }
  return pass
}

/**
 * filter
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, role, features, relationRole) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(role, route, features, relationRole)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, role, features, relationRole)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  getters: {
    permission_routers: state => state.routers,
    addRouters: state => state.addRouters
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    },
    RESET_ROUTERS: (state) => {
      state.addRouters = []
      state.routers = constantRouterMap
    },
    CLEAR_ROUTERS: (state) => {
      state.addRouters = []
      state.routers = null
    }
  },
  actions: {
    GenerateRoutes({ commit }, { role, confirmed, awakRole, userData, features, relationRole }) {
      return new Promise(resolve => {
        let accessedRouters
        switch (role) {
          case 'finazamanager': {
            accessedRouters = filterAsyncRouter(asyncRouterMap, role, features, relationRole)
            break
          }
          case 'generalmanager': {
            accessedRouters = filterAsyncRouter(asyncRouterMap, role, features, relationRole)
            break
          }
          case 'authenticated': {
            accessedRouters = filterAsyncRouter(asyncRouterMap, role, features, relationRole)
            break
          }
          default: {
            accessedRouters = filterAsyncRouter(unconfirmedRouterMap, role, features, relationRole)
            break
          }
        }

        // console.log(accessedRouters)

        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    },
    ResetRoutes({ commit }) {
      return new Promise(resolve => {
        commit('RESET_ROUTERS')
        resolve()
      })
    },
    ClearRoutes({ commit }) {
      return new Promise(resolve => {
        commit('CLEAR_ROUTERS')
        resolve()
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js